function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "exit-1",
  d: "M17.42,14.64c-1.92,0-3.47,1.55-3.47,3.47v27.78c0,1.92,1.55,3.47,3.47,3.47h6.94c1.92,0,3.47,1.55,3.47,3.47s-1.55,3.47-3.47,3.47h-6.94c-5.75,0-10.42-4.67-10.42-10.42v-27.78c0-5.75,4.67-10.42,10.42-10.42h6.94c1.92,0,3.47,1.55,3.47,3.47s-1.55,3.47-3.47,3.47h-6.94Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "exit-1",
  d: "M55.98,34.55l-13.89,14.39c-1.36,1.41-3.56,1.41-4.92,0s-1.36-3.69,0-5.09l7.97-8.25h-22.86c-1.92,0-3.47-1.61-3.47-3.6s1.55-3.6,3.47-3.6h22.86l-7.97-8.25c-1.36-1.41-1.36-3.69,0-5.09s3.56-1.41,4.92,0l13.89,14.39c1.36,1.41,1.36,3.69,0,5.09h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/exitIcon.97dfdac9.svg";
export { SvgComponent as ReactComponent };